import jQuery from 'jquery';
import 'bootstrap';
import axios from 'axios';
import { Echo } from './plugins/pusher';
/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
  window.jQuery = jQuery;
  window.$ = window.jQuery;
} catch (e) {
  console.error(e);
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

const token = document.head.querySelector('meta[name="csrf-token"]');

const now = new Date();
const storageToken = JSON.parse(localStorage.getItem('cookietoken'));
if (!storageToken || storageToken?.expiry < now.getTime()) {
  axios.get('/sanctum/csrf-cookie').then((response) => {
    const cookietoken = {
      token: response.config.headers['X-CSRF-TOKEN'],
      expiry: now.getTime() + 60 * 60 * 1000,
    };
    localStorage.setItem('cookietoken', JSON.stringify(cookietoken));
  });
}

if (token) {
  axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
  axios.defaults.headers.common.Authorization = `Bearer ${window.appState.access_token}`;

  // // 1. ตรวจสอบและแนบ CSRF Token (ถ้ามี)
  // const csrfToken = document.head.querySelector('meta[name="csrf-token"]');
  // if (csrfToken) {
  //   axios.defaults.headers.common['X-CSRF-TOKEN'] = csrfToken.content;
  // } else if (typeof token !== 'undefined' && token && token.content) {
  //   // ใช้จากตัวแปร token ของคุณถ้าดึงมาจากที่อื่น
  //   axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
  // }

  // // 2. ตรวจสอบและแนบ Bearer Token สำหรับ API
  // if (window.appState && window.appState.access_token) {
  //   axios.defaults.headers.common['Authorization'] = `Bearer ${window.appState.access_token}`;
  // }
  axios.defaults.withCredentials = true;
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

window.Echo = Echo;
